import TopStats from "../Component/Home/TopSatats";
import MainContent from "../Component/Home/MainContent";
import MediaSection from "../Component/Home/MediaSection";
import RightBar from "../Component/rightbar";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Home() {

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-9">
            <div className="row">
              <TopStats/>
              <MainContent/>
              <MediaSection/>
            </div>
          </div>
          <RightBar/>
        </div>
      </div>
    </>
  );
}

export default Home;
